import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { track } from "@/lib/analytics";

const CheckupStickyMobileCta = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Only appear after the user scrolls past the hero (avoids stacking with hero CTA)
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToForm = () => {
    track("sticky_mobile_cta_clicked", { label: "Get My Growth Score + 90-Day Plan" });
    document.getElementById("checkup-form")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 md:hidden bg-hero-bg/95 backdrop-blur-sm border-t border-border p-3 transition-transform duration-300 ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
      aria-hidden={!show}
    >
      <button
        onClick={scrollToForm}
        className="w-full flex items-center justify-center gap-2 bg-accent text-accent-foreground py-3 rounded-lg text-sm font-semibold shadow-lg shadow-accent/25 active:scale-[0.97] transition-all"
      >
        Get My Growth Score + 90-Day Plan
        <ArrowRight className="w-4 h-4" />
      </button>
      <p className="text-center text-[10px] text-hero-foreground/50 mt-1.5">
        No call · No pitch · Delivered in ~3 business days
      </p>
    </div>
  );
};

export default CheckupStickyMobileCta;
